import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';
import CreditCardInput from 'Components/forms/credit-card-input/CreditCardInput.jsx';
import CurrencyRangeInput from 'Components/forms/currency-range-input/CurrencyRangeInput.jsx';
import DualDateInput from 'Components/forms/DualDateInput';
import TextInput from 'Components/forms/text-input/TextInput.jsx';
import MultiSelectInput from 'Components/forms/multiselect-input/MultiSelectInput.jsx';
import SelectInput from 'Components/forms/select-input/SelectInput.jsx';
import YearMonthPicker from 'Components/forms/year-month-input/YearMonthPicker.jsx';
import SingleDateInput from 'Components/forms/SingleDateInput/SingleDateInput';
import CurrencySingleInput from '../forms/currency-single-input';
import ReasonCode from 'Components/ReasonCode/ReasonCode.jsx';
import MerchantNumbers from 'Components/MerchantNumbers/MerchantNumbers.jsx';
import DualMerchantDataListSelector from 'Components/DualMerchantDataListSelector/DualMerchantDataListSelector.jsx';
import './FilterElement.scss';

const FilterElement = ({
  currentValues,
  listHeight,
  isSortFilter,
  dateFormat,
  extraClass,
  filter,
  onChange,
  onRangeChange,
  onCurrencyChange,
  translations,
  handleDualDates,
  handleMonthChange,
  handleSelection,
  handleSingleSelection,
  onSingleDateChange,
  id,
  removeFilterAction,
  showDynamicFilter,
  updatedId,
  handleOutsideClick,
  toggleCollapse,
  toggleSearchDropDown,
  updateIsIndeterminate,
  currentSearchTerm,
  visible,
  handleChange,
  handleHeaderCheckbox,
  searchReasonCode,
  isMerchantUser,
  defaultSelected,
  removeTopMargin,
  reportName,
  isMreFilter,
  isBetweenOptionSelected,
  isViewFilter,
  isAllMerchantSelected,
  priorityOrderViewOnly,
  isEditRule,
  midPage,
  currentMidCount,
  totalMidCount,
  selectedMerchantNumbers,
  excludedMidNumbers,
  totalMidPages,
  langCode,
  updateIsMerchantIndeterminate,
  disabledMerchantNumbers,
  isMreFilterPaneVisible,
  secondFieldHandleSection,
  isArchival,
  totalChainPages,
  acquirerCode,
  handleDualSelectorChanges,
  isClearAllFilters,
  isMerchantNumberError,
  whiteLabelingFlag,
  readOnly,
  updatedMerchantNumbers,
  showRemoveLabel
}) => {
  const wrapperClass = classnames(filter?.elementId == "portfolio" ? "filter-element-two-element" :
  (reportName == 'Unresolved RTI' ? 'filter-element-four-element' : reportName == 'MRE' ? filter.elementId == 'mre_currency_code' || filter.elementId == 'mre_cmp_dspt_amt' || filter.elementId == 'mre_dispute_amount' || filter.elementId == 'mre_dspt_amt_frm-mre_dspt_amt_to' 
  ? 'filter-element-mre-currency' :  (langCode == 'FC') ? 'filter-element-mre-fc':'filter-element-mre' : 'filter-element'), {
   [extraClass]: extraClass,
 });

  let inputComponent;

  switch (filter.elementTypeName) {
    case 'SELECT': {
      const inputValues = filter.filterValues.map((obj) => {
        return Object.assign({},
          { id: obj.id },
          { value: obj.value },
          { text: obj.valueLabel },
          { desc: obj.desc },
          { filterValueGroupId: obj.filterValueGroupId },
        );
      });

      const selectedFilterValue = (currentValues &&
        currentValues.v1 &&
        currentValues.v1.length)
        ? filter.filterValues?.find((fVal) => {
          return fVal.value === currentValues.v1;
        })
        : null;

      const selectedItem = (selectedFilterValue)
        ? { value: selectedFilterValue.value, text: selectedFilterValue.valueLabel }
        : null;

      const choosePrompt = `${translations.select} ${filter.elementLabel}`;

      inputComponent = (
        <SelectInput
          name={filter.id}
          key={filter.id}
          dataList={inputValues}
          promptText={choosePrompt}
          wrapperClass="select-menu__form"
          label={filter.elementLabel}
          handleSelection={handleSingleSelection}
          selectedItem={selectedItem}
          id={`${id}_selectInput_${filter.elementId}`}
          removeFilterAction={removeFilterAction}
          updatedId={filter.id}
          showDynamicFilter= {showRemoveLabel } 
          extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
          extraSpanClass="main-span-label"
          filterErrorMsg={filter.filterErrorMsg}

        />
      );
      break;
    }
    case 'DROPDOWN': {
      const selectedFilterValue = (currentValues &&
        currentValues.v1 && currentValues.v1.length)
        ? (filter != undefined && filter.filterValues != undefined) ?
          filter.filterValues?.find((fVal) => {
            return fVal.value === currentValues.v1;
          })
          : null : null;

      let selectedItem = (selectedFilterValue)
        ? { value: selectedFilterValue.value, text: selectedFilterValue.text }
        : null;

      let choosePrompt = `${translations.select} ${filter.elementLabel}`;
      if (isSortFilter) {
        if (filter.elementId === 'cq_sort_pri_sort' || filter.elementId === 'cq_sort_sec_sort') {
          if (filter.filterValues != undefined && filter.filterValues.length > 0) {
            filter.filterValues.filter(obj => obj.value == 'cb').map(ele => {
              choosePrompt = ele.text;
            });
          }
        }
        if (filter.elementId === 'cq_sort_pri_sort_odr' || filter.elementId === 'cq_sort_sec_sort_odr') {
          if (filter.filterValues != undefined && filter.filterValues.length > 0) {
            filter.filterValues.filter(obj => obj.value == 'ASC').map(ele => {
              choosePrompt = ele.text;
            });
          }
        }
      }
      let elementLabel = filter.elementLabel;
      if (filter.elementSection == "rule_criteria") {
        choosePrompt = `${translations.select}`;
        if (filter.elementId == "mre_currency_code") {
          elementLabel = `${translations.caseAmount}`;
          choosePrompt = `${translations.currency}`;
        } else if (filter.elementSection == "rule_criteria" && filter.elementId == "mre_cmp_dspt_amt") {
          elementLabel = "";
          choosePrompt = `${translations.select}`;
        }
      } else if (filter.elementSection == "create_rule") {
        choosePrompt = `${translations.select}`;
        if (filter.elementId == "mre_priority_order" && isViewFilter) {
          choosePrompt = priorityOrderViewOnly
        }
      }

      if(acquirerCode === 'HPY' && filter.elementId === "mre_currency_code") {
        inputComponent = (
          <TextInput
            key={filter.id}
            name={showDynamicFilter ? updatedId : filter.id}
            label={elementLabel}
            type="text"
            onChange={onChange}
            placeholder={placeHolder}
            value={'USD'}
            removeFilterAction={removeFilterAction}
            showDynamicFilter={showDynamicFilter}
            updatedId={updatedId}
            extraClassLabel={(filter.elementId == 'cq_name' || filter.elementId == 'mre_rule_name' || filter.elementId == 'mre_description') ? "mandatory-field" : ''}
            filterErrorMsg={filter.filterErrorMsg}
            reportName={reportName}
            disable={true}
          />);
      } else {
        inputComponent = (
          <SelectInput
            name={filter.id}
            key={filter.id}
            dataList={filter.filterValues}
            promptText={choosePrompt}
            wrapperClass="select-menu__form"
            label={elementLabel}
            handleSelection={handleSingleSelection}
            selectedItem={selectedItem}
            id={`${id}_selectInput_${filter.elementId}`}
            removeFilterAction={removeFilterAction}
            updatedId={filter.id}
            showDynamicFilter={
            filter.elementMandatory ||
            filter.elementId != "sort_1" ||
            filter.elementId != "sort_odr_1"
              ? false
              : true
            }
            extraStyle={{ fontSize: 12, fontWeight: 500, color: "#7C7C89" }}
            extraSpanClass={
              filter.elementId == "mre_currency_code" ? "main-span-label" : filter.elementMandatory ||
              filter.elementId != "sort_1" ||
              filter.elementId != "sort_odr_1"
                ? "mandatory-field"
                : "main-span-label"
              }
            reportName={reportName}
            isDisabled={isViewFilter}
            disableClick={isViewFilter}
            filterErrorMsg={filter.filterErrorMsg}
          />
        );
      }
      break;
    }

    case 'SINGLE_DATE': {
      const singleDate = moment(currentValues.v1).format(dateFormat);
      inputComponent = (
        <SingleDateInput
          id={filter.id}
          name={filter.id}
          onApply={onSingleDateChange}
          title={filter.elementLabel}
          singleDate={singleDate}
          minDate={moment().subtract(10, 'years')}
          dateFormat={dateFormat}
          isMerchantUser={isMerchantUser}
        />
      );
      break;
    }
    case 'MULTISELECT': {
      const inputValues = filter.filterValues;
      const selectedItems = [];
      if (currentValues && currentValues.v1 && currentValues.v1.length) {
        currentValues.v1 = currentValues.v1.includes(",") && !Array.isArray(currentValues.v1) ? currentValues.v1.split(",") : Array.isArray(currentValues.v1) ? currentValues.v1 : [currentValues.v1];
        currentValues.v1.forEach(((element) => {
          const selectedElement = filter.filterValues?.find((data) => {
            return element == data.value;
          });
          selectedElement && selectedItems.push({ value: selectedElement.value, text: selectedElement.text });
        }));
      }

      const choosePrompt = `${translations.select} ${filter.elementLabel}`;

      inputComponent = (
        <MultiSelectInput
          // @todo handleSelection
          name={filter.id}
          key={filter.id}
          dataList={inputValues}
          promptText={choosePrompt}
          wrapperClass="select-menu__form"
          label={filter.elementLabel}
          handleSelection={handleSelection}
          selectedItem={selectedItems}
          showDynamicFilter={showDynamicFilter}
          extraSpanClass={filter.elementMandatory ? "mandatory-field" : 'main-span-label'}
          removeFilterAction={removeFilterAction}
          updatedId={filter.id}
          defaultSelected={defaultSelected}
          reportName={reportName}

        />
      );
      break;
    }
    case 'DYNAMIC_MULTISELECT': {
      const inputValues = filter.filterValues;
      const selectedItems = [];
      if (currentValues && currentValues.v1 && currentValues.v1.length) {
        currentValues.v1 = currentValues.v1.includes(",") && !Array.isArray(currentValues.v1) ? currentValues.v1.split(",") : Array.isArray(currentValues.v1) ? currentValues.v1 : [currentValues.v1];
        currentValues.v1.forEach(((element) => {
          const selectedElement = filter.filterValues?.find((data) => {
            element = element.trim();
            if (element.includes('[') || element.includes(']')) {
              element = element.replace('[', '');
              element = element.replace(']', '');
            }

            return element == data.value;
          });
          selectedElement && selectedItems.push({ value: selectedElement.value, text: selectedElement.text });
        }));
      }
      let choosePrompt = `${translations.select} ${filter.elementLabel}`;
      if(filter.elementId === 'mre_card_brand') {
        choosePrompt = `${translations.select}`
      }
      if (filter.elementId === 'mre_merchant_numbers' || filter.elementId === 'mre_mcc') {
        const inputValues = filter.filterValues;
        inputComponent = (
          <MerchantNumbers
            key={filter.id}
            name={showDynamicFilter ? updatedId : filter.id}
            title={filter.elementLabel}
            type="text"
            onChange={searchReasonCode}
            selectedValue={currentValues.v1}
            removeFilterAction={removeFilterAction}
            searchTerm={currentSearchTerm}
            updatedId={showDynamicFilter ? updatedId : filter.id}
            handleOutsideClick={handleOutsideClick}
            toggleCollapse={toggleCollapse}
            onClick={toggleSearchDropDown}
            dataList={inputValues}
            visible={filter.visibility}
            handleChange={handleChange}
            handleHeaderCheckbox={handleHeaderCheckbox}
            updateIsIndeterminate={updateIsIndeterminate}
            showDynamicFilter={filter.elementMandatory ? false : showDynamicFilter}
            listHeight={listHeight}
            placeHolder={translations.search}
            elementId={filter.elementId}
            filterErrorMsg={filter.filterErrorMsg}
            reportName={reportName}
            isAllMerchantSelected={isAllMerchantSelected}
            allMerchantSelectedMsg={translations.allMerchantsSelected}
            isViewFilter={isViewFilter}
            isEditRule={isEditRule}
            elementLabel={translations.select}
            midPage={midPage}
            currentMidCount={currentMidCount}
            totalMidCount={totalMidCount}
            selectedMerchantNumbers={selectedMerchantNumbers}
            excludedMidNumbers={excludedMidNumbers}
            totalMidPages={totalMidPages}
            pageLabel={translations.page}
            ofLabel={translations.of}
            updateIsMerchantIndeterminate={updateIsMerchantIndeterminate}
            disabledMerchantNumbers={disabledMerchantNumbers}
            isMreFilterPaneVisible={isMreFilterPaneVisible}
            totalChainPages={totalChainPages}
          />)
      } else {
        inputComponent = (
          <MultiSelectInput
            // @todo handleSelection
            name={filter.id}
            key={filter.id}
            dataList={inputValues}
            promptText={choosePrompt}
            wrapperClass="select-menu__form"
            label={filter.elementLabel}
            handleSelection={handleSelection}
            selectedItem={selectedItems}
            removeFilterAction={removeFilterAction}
            updatedId={filter.id}
            showDynamicFilter={(reportName != null && reportName == "Unresolved RTI") ? false : showDynamicFilter !== null && showDynamicFilter !== undefined ? showDynamicFilter : true}
            extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
            extraSpanClass={filter.elementMandatory && (filter.elementId != 'mre_card_brand') ? "mandatory-field" : 'main-span-label'}
            isCreateQueue={filter.elementSection == "create_queue" ? true : false}
            removeTopMargin={removeTopMargin}
            isDisabled={filter?.isDisabled ? filter?.isDisabled : isViewFilter}
            hideLabel={filter?.hideLabel}
            customeElementLabel={filter?.customeElementLabel}
            reportName={reportName}
            filterErrorMsg={filter.filterErrorMsg}
          />
        );
      }
      break;
    }
    case 'CURRENCYRANGE': {
      if (isMreFilter) {
        if (isBetweenOptionSelected == true) {
          inputComponent = (
            <CurrencyRangeInput
              id={filter.id}
              key={filter.id}
              filterLow={currentValues.v1}
              filterHigh={currentValues.v2}
              onChange={onRangeChange}
              title={""}
              separatorText=""
              removeFilterAction={removeFilterAction}
              showDynamicFilter={showDynamicFilter}
              updatedId={updatedId}
              valueLow={translations.low}
              valueHigh={translations.high}
              disable={isViewFilter}
              reportName={reportName}
              max={filter?.max}
            />
          );
        }
      } else {
        inputComponent = (
          <CurrencyRangeInput
            id={filter.id}
            key={filter.id}
            filterLow={currentValues.v1}
            filterHigh={currentValues.v2}
            onChange={onRangeChange}
            title={filter.elementLabel}
            separatorText={translations.dates.to}
            removeFilterAction={removeFilterAction}
            showDynamicFilter={showDynamicFilter}
            updatedId={updatedId}
            max={filter?.max}
            validationError={filter?.errorMsg}
          />
        );
      }
      break;
    }
    case 'CURRENCYEXACT': {
      if (isMreFilter) {
        if (!isBetweenOptionSelected) {
          inputComponent = (
            <CurrencySingleInput
              id={filter.id}
              key={filter.id}
              filterLow={currentValues.v1}
              // filterHigh={currentValues.v2}
              onChange={onCurrencyChange}
              title={""}
              separatorText={translations.to}
              placeHolder={translations.enterAmount}
              disable={isViewFilter}
            />
          );
        }
      } else {
        inputComponent = (
          <CurrencySingleInput
            id={filter.id}
            key={filter.id}
            filterLow={currentValues.v1}
            // filterHigh={currentValues.v2}
            onChange={onCurrencyChange}
            title={filter.elementLabel}
            separatorText={translations.to}
          />
        );
      }
      break;
    }
    case 'CC_NUMBER': {


      // @todo refactor handling credit card filter change events
      inputComponent = (
        <CreditCardInput
          id={filter.id}
          key={filter.id}
          label={filter.elementLabel}
          onSelectChange={null}
          onChange={onRangeChange}
          v1={currentValues.v1}
          v2={currentValues.v2}
          selectedInput={filter.cardOption}
          translations={translations}
          removeFilterAction={removeFilterAction}
          showDynamicFilter={showDynamicFilter}
          updatedId={updatedId}
        />
      );
      break;
    }
    case 'FULL_CC_NUMBER': {
      inputComponent = (
        <TextInput
          key={filter.id}
          name={filter.id}
          label={filter.elementLabel}
          type="text"
          onChange={onChange}
          placeholder=""
          value={currentValues.v1}
          extraStyle={{ fontSize: 12, fontWeight: 500, color: '#000000' }}
        />
      );
      break;
    }
    case 'DATE': {
      let fromDate = currentValues.v1;
      let endDate = currentValues.v2;

      let defaultSelect = false;
      let isFutureDateDisable = false;
      let isDefaultDateSelected = (filter.id === 'fromTransactionDate' || 'fromAuthorizationDate') ? true : false;
      const yesterDay = moment().subtract(1, 'days');
      const newDate = moment(yesterDay).subtract(3, 'months');
      if ((filter.id === 'fromTransactionDate' || filter.id === 'fromAuthorizationDate') && (fromDate == undefined || fromDate == null)) {
        fromDate = moment(newDate).format(dateFormat);
        endDate = moment(yesterDay).format(dateFormat);
        defaultSelect = true;
      } else if ((filter.id === "mp_case_rc_from_date-mp_case_rc_to_date")) {
        isFutureDateDisable = true;
      }
      inputComponent = (
        <DualDateInput
          id={filter.id}
          key={filter.id}
          onApply={handleDualDates}
          title={filter.elementLabel}
          startDate={fromDate}
          endDate={endDate}
          dateFormat={dateFormat}
          translations={translations.dates}
          defaultSelect={defaultSelect}
          isDefaultDateSelected={isDefaultDateSelected}
          removeFilterAction={removeFilterAction}
          showDynamicFilter={showDynamicFilter}
          updatedId={updatedId}
          isMerchantUser={isMerchantUser}
          isArchival={isArchival}
          isFutureDateDisable={isFutureDateDisable}
        />
      );
      break;
    }
    case 'MONTH_CALENDAR': {
      inputComponent = (
        <YearMonthPicker
          id={filter.id}
          key={filter.id}
          currentValues={currentValues}
          handleMonthChange={handleMonthChange}
          title={filter.elementLabel}
        />
      );
      break;
    }
    case 'GROUP_SEARCH': {
      const inputValues = filter.filterValues;
      inputComponent = (
        <ReasonCode
          key={filter.id}
          name={showDynamicFilter ? updatedId : filter.id}
          title={filter.elementLabel}
          type="text"
          onChange={searchReasonCode}
          selectedValue={currentValues.v1}
          removeFilterAction={removeFilterAction}
          searchTerm={currentSearchTerm}
          updatedId={showDynamicFilter ? updatedId : filter.id}
          handleOutsideClick={handleOutsideClick}
          toggleCollapse={toggleCollapse}
          onClick={toggleSearchDropDown}
          dataList={inputValues}
          visible={filter.visibility}
          handleChange={handleChange}
          handleHeaderCheckbox={handleHeaderCheckbox}
          updateIsIndeterminate={updateIsIndeterminate}
          showDynamicFilter={filter.elementMandatory ? false : showDynamicFilter}
          listHeight={listHeight}
          placeHolder={filter}
          elementId={filter.elementId}
          disabled={isViewFilter}
          mreCustomHolder={`${translations.search}`}
          isMreFilterPaneVisible={isMreFilterPaneVisible}
          reportName={reportName}
        />
      );
      break;
    }
    case 'DYNAMIC_MULTITEXT': {
      inputComponent = (
        <TextInput
          key={filter.id}
          name={showDynamicFilter ? updatedId : filter.id}
          label={filter.elementLabel}
          type="text"
          onChange={onChange}
          placeholder=""
          value={currentValues.v1}
          removeFilterAction={removeFilterAction}
          showDynamicFilter={showDynamicFilter}
          updatedId={updatedId}
          max={filter?.max}
          error={filter?.errorMsg}
        />
      );
      break;
    }
    case 'TWO_MULTISELECT': {
      const inputValues = filter.filterValues;
      const SecondInputValues = filter.filterValuesSecondField;
      const selectedItems = [];
      const SecondSelectedItems = [];
      if (currentValues && currentValues.v1 && currentValues.v1.length) {
        currentValues.v1 = currentValues.v1.includes(",") && !Array.isArray(currentValues.v1) ? currentValues.v1.split(",") : Array.isArray(currentValues.v1) ? currentValues.v1 : [currentValues.v1];
        currentValues.v1.forEach(((element) => {
          const selectedElement = filter.filterValues?.find((data) => {
            element = element.trim();
            if (element.includes('[') || element.includes(']')) {
              element = element.replace('[', '');
              element = element.replace(']', '');
            }
            return element == data.value;
          });
          selectedElement && selectedItems.push({ value: selectedElement.value, text: selectedElement.text });
        }));
      }

      if (currentValues && currentValues.v2 && currentValues.v2.length) {
        currentValues.v2 = currentValues.v2.includes(",") && !Array.isArray(currentValues.v2) ? currentValues.v2.split(",") : Array.isArray(currentValues.v2) ? currentValues.v2 : [currentValues.v2];
        currentValues.v2.forEach(((element) => {
          const secSelectedElement = filter.filterValuesSecondField?.find((data) => {
            element = element.trim();
            if (element.includes('[') || element.includes(']')) {
              element = element.replace('[', '');
              element = element.replace(']', '');
            }
            return element == data.value;
          });
          secSelectedElement && SecondSelectedItems.push({ value: secSelectedElement.value, text: secSelectedElement.text });
        }));
      }

      const choosePrompt = `${translations.select} ${filter.elementPlaceHolder}`;
      const SecondChoosePrompt = `${translations.select} ${filter.elementLabelSecond}`;
      inputComponent = (
        <div style={{ display: "flex" }}>
          <span style={{ width: "50%" }}>
            <MultiSelectInput
              name={filter.id}
              key={filter.id}
              dataList={inputValues}
              promptText={choosePrompt}
              wrapperClass="select-menu__form"
              label={filter.elementLabel}
              handleSelection={handleSelection}
              selectedItem={selectedItems}
              removeFilterAction={removeFilterAction}
              updatedId={filter.id}
              showDynamicFilter={(reportName != null && reportName == "Unresolved RTI") ? false : showDynamicFilter !== null && showDynamicFilter !== undefined ? showDynamicFilter : true}
              extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
              extraSpanClass="main-span-label"
              isCreateQueue={filter.elementSection == "create_queue" ? true : false}
              removeTopMargin={removeTopMargin}
              isDisabled={filter?.isDisabled}
              hideLabel={filter?.hideLabel}
              customeElementLabel={filter?.customeElementLabel}
              reportName={reportName}
            />
          </span>
          <span style={{ width: "50%", marginLeft: "30px" }}>
            <MultiSelectInput
              name={filter.id}
              key={filter.id}
              dataList={SecondInputValues}
              promptText={SecondChoosePrompt}
              wrapperClass="select-menu__form"
              label={filter.elementLabel}
              handleSelection={secondFieldHandleSection}
              selectedItem={SecondSelectedItems}
              removeFilterAction={removeFilterAction}
              updatedId={"secondField"}
              showDynamicFilter={false}
              extraStyle={{ fontSize: 12, fontWeight: 500, color: '#7C7C89' }}
              extraSpanClass="main-span-label"
              isCreateQueue={filter.elementSection == "create_queue" ? true : false}
              removeTopMargin={removeTopMargin}
              isDisabled={filter?.isDisabled}
              hideLabel={true}
              customeElementLabel={filter?.customeElementLabel}
              reportName={reportName}
            />
          </span>
        </div>
      );
      break;
    }
    case 'DUALLIST_GRPSEARCH': {
      inputComponent = (
        <DualMerchantDataListSelector
          id={filter.id}
          label={filter.elementLabel}
          availableMerchantNumbers={filter.filterValues}
          selectedMerchantNumbers={selectedMerchantNumbers}
          reportName={reportName}
          isMreFilterPaneVisible={isMreFilterPaneVisible}
          filterErrorMsg={filter.filterErrorMsg}
          handleDualSelectorChanges={handleDualSelectorChanges}
          isEditRule={isEditRule}
          isViewFilter={isViewFilter}
          isClearAllFilters={isClearAllFilters}
          isMerchantNumberError={isMerchantNumberError}
          translations={translations}
          whiteLabelingFlag={whiteLabelingFlag}
          isAllMerchantSelected={isAllMerchantSelected}
          allMerchantSelectedMsg={translations.allMerchantsSelected}
          updatedMerchantNumbers={updatedMerchantNumbers}
        />
      );
      break;
    }
    case 'STRING':
      let placeHolder = "";
      if(filter.elementId == 'mre_rule_name') {
        placeHolder = translations.enterRuleName
      } else if(filter.elementId == 'mre_description') {
        placeHolder = translations.enterDescription
      }
      
    default: {
      let placeHolder = "";
      if(filter.elementId == 'mre_rule_name') {
        placeHolder = translations.enterRuleName
      } else if(filter.elementId == 'mre_description') {
        placeHolder = translations.enterDescription
      }
      inputComponent = (
        <TextInput
          key={filter.id}
          name={showDynamicFilter ? updatedId : filter.id}
          label={filter.elementLabel}
          type="text"
          onChange={onChange}
          placeholder={placeHolder}
          value={currentValues.v1}
          removeFilterAction={removeFilterAction}
          showDynamicFilter={showDynamicFilter}
          updatedId={updatedId}
          extraClassLabel={(filter.elementId == 'cq_name' || filter.elementId == 'mre_rule_name' || filter.elementId == 'mre_description') ? "mandatory-field" : ''}
          filterErrorMsg={filter.filterErrorMsg}
          reportName={reportName}
          disable={isViewFilter}
          readOnly={readOnly}
          min={filter?.min}
          max={filter?.max}
          error={filter?.errorMsg}
        />
      );
    }
  }

    return (
      <div className={inputComponent ? wrapperClass : wrapperClass + ' filter-element-mre-currency-undefined'}>
        {inputComponent}
      </div>
    );
};

FilterElement.propTypes = {
  currentValues: PropTypes.object,
  dateFormat: PropTypes.string.isRequired,
  extraClass: PropTypes.string,
  filter: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onRangeChange: PropTypes.func.isRequired,
  onCurrencyChange: PropTypes.func.isRequired,
  translations: PropTypes.object,
  handleDualDates: PropTypes.func.isRequired,
  handleMonthChange: PropTypes.func.isRequired,
  handleSelection: PropTypes.func,
  defaultSelected: PropTypes.func,
  handleSingleSelection: PropTypes.func,
  id: PropTypes.string,
  removeFilterAction: PropTypes.func,
  showDynamicFilter: PropTypes.bool,
  updatedId: PropTypes.string,
  reportName: PropTypes.string,
  secondFieldHandleSection: PropTypes.func,
  isMreFilter: PropTypes.bool,
  isBetweenOptionSelected: PropTypes.bool,
  isViewFilter: PropTypes.bool,
  isAllMerchantSelected: PropTypes.bool,
  priorityOrderViewOnly: PropTypes.string,
  isEditRule: PropTypes.bool,
  midPage: PropTypes.number,
  currentMidCount: PropTypes.number,
  totalMidCount: PropTypes.number,
  selectedMerchantNumbers: PropTypes.array,
  excludedMidNumbers: PropTypes.array,
  totalMidPages: PropTypes.number,
  langCode: PropTypes.string,
  updateIsMerchantIndeterminate: PropTypes.func,
  disabledMerchantNumbers: PropTypes.number,
  isMreFilterPaneVisible: PropTypes.bool,
  isArchival: PropTypes.bool,
  totalChainPages: PropTypes.number,
  totalChainCount: PropTypes.number,
  disabledChainNumbers: PropTypes,
  acquirerCode: PropTypes.string,
  handleDualSelectorChanges: PropTypes.func,
  isClearAllFilters: PropTypes.bool,
  isMerchantNumberError: PropTypes.bool,
  whiteLabelingFlag: PropTypes.bool,
  updatedMerchantNumbers: PropTypes.array,
  readOnly: PropTypes.bool,
  showRemoveLabel : PropTypes.bool,
};

FilterElement.defaultProps = {
  currentValues: {},
  extraClass: '',
  translations: {
    select: 'Select',
    to: 'To',
  },
  id: '',
  defaultSelected: () => { },
  handleSelection: () => { },
  handleSingleSelection: () => { },
  removeFilterAction: () => { },
  showDynamicFilter: false,
  updatedId: '',
  reportName: '',
  secondFieldHandleSection: () => { },
  isMreFilter: false,
  isBetweenOptionSelected: false,
  isViewFilter: false,
  isAllMerchantSelected: false,
  priorityOrderViewOnly: '',
  isEditRule: false,
  midPage: 0,
  currentMidCount: 0,
  totalMidCount: 0,
  selectedMerchantNumbers: [],
  excludedMidNumbers: [],
  totalMidPages: 0,
  langCode: '',
  updateIsMerchantIndeterminate: () => { },
  disabledMerchantNumbers: 0,
  isMreFilterPaneVisible: false,
  totalChainPages: 0,
  totalChainCount: 0,
  disabledChainNumbers: 0,
  acquirerCode: '',
  handleDualSelectorChanges: () => { },
  isClearAllFilters: false,
  isMerchantNumberError: false,
  isArchival: false,
  whiteLabelingFlag: false,
  updatedMerchantNumbers: [],
  readOnly:false,
  showRemoveLabel : true 
};

export default FilterElement;
